import React, { createContext, FC, useContext } from "react";

import { useLoginState } from "~/components/Login/hooks/useLoginState/useLoginState";
import { emptyCallback } from "~/util/emptyCallback";

export type LoginStateContextType = {
  orderId: string;
  setOrderId: (orderId: string) => void;
  customerEmail: string;
  setCustomerEmail: (customerEmail: string) => void;
  resetLoginState: () => void;
  isDisableCTA: boolean;
  setLoginSuccess: (isLoginSuccess: boolean) => void;
  loginSuccess: boolean;
  loginCredentials: { orderId: string; customerEmail: string; flow: string };
  completeLogin: (orderId: string, customerEmail: string, flow: string) => void;
};

export const LoginStateContext = createContext<LoginStateContextType>({
  orderId: "",
  setOrderId: emptyCallback,
  customerEmail: "",
  setCustomerEmail: emptyCallback,
  resetLoginState: emptyCallback,
  isDisableCTA: false,
  setLoginSuccess: emptyCallback,
  loginSuccess: false,
  loginCredentials: { orderId: "", customerEmail: "", flow: "" },
  completeLogin: emptyCallback,
});

type LoginStateContextProviderProps = {
  orderId: string;
  setOrderId: (orderId: string) => void;
  customerEmail: string;
  setCustomerEmail: (customerEmail: string) => void;
  setLoginSuccess: (isLoginSuccess: boolean) => void;
  loginSuccess: boolean;
  loginCredentials: { orderId: string; customerEmail: string; flow: string };
  completeLogin: (orderId: string, customerEmail: string, flow: string) => void;
};

export const LoginStateContextProvider: FC<LoginStateContextProviderProps> = ({
  children,
  orderId,
  setOrderId,
  customerEmail,
  setCustomerEmail,
  setLoginSuccess,
  loginSuccess,
  loginCredentials,
  completeLogin,
}) => {
  const value = {
    ...useLoginState({
      orderId,
      setOrderId,
      customerEmail,
      setCustomerEmail,
      setLoginSuccess,
    }),
    orderId,
    setOrderId,
    customerEmail,
    setCustomerEmail,
    setLoginSuccess,
    loginSuccess,
    loginCredentials,
    completeLogin,
  };
  return (
    <LoginStateContext.Provider value={value}>
      {children}
    </LoginStateContext.Provider>
  );
};

export const useLoginStateContext = () => useContext(LoginStateContext);
